export enum DataExchangeRequestDeadlineStateDto {
  None = 0,
  OnTrack = 1,
  CloseToExpiry = 2,
  Expired = 3
}
